import { useService } from 'react-reservice';

import { getUseServiceWithSubscriptionKeys } from '@webtrader/core/utils';

import technicalIndicatorService from './service';

export const useTechnicalIndicator = () => {
  return useService(technicalIndicatorService, (state) => state);
};

export const useTechnicalIndicatorWithKeys = getUseServiceWithSubscriptionKeys(technicalIndicatorService);

export { technicalIndicatorService };
